<template>
  <div>
    <TableScrollbar
      class="list-projects__results-table table-container-new"
      :class="{ 'table-list-projects__table-loading': isLoading }"
    >
      <table class="stockTable table-list-projects">
        <thead>
          <tr>
            <th
              class="table-list-projects__td table-list-projects__td_size-xs mpk-first-column-fixed"
              scope="col"
              v-if="canEdit || canDelete"
            ></th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <p>Полное название</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-m" scope="col">
              <p>Статус</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <p>Страна</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <p>Председатель Российской части</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <p>Председатель иностранной части</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <p>Заместитель председателя Российской части</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <p>Ответственный секретарь Российской части</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-m" scope="col">
              <p>Встреча сопредседателей</p>
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-m" scope="col">
              <p>Заседание</p>
            </th>
          </tr>
          <tr>
            <th
              class="table-list-projects__td table-list-projects__td_size-xs mpk-first-column-fixed"
              scope="col"
              v-if="canEdit || canDelete"
            ></th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <ComponentInput
                placeholder="Название"
                mod="filter"
                v-model="localFilter.name"
                clearButton
                @onClear="handleClear('name')"
              />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-m" scope="col">
              <SelectMultiComponent
                v-model="localFilter.statusId"
                :options="statusOptions"
                valueProp="value"
                placeholder="Статус"
                modifier="rectangular"
                clearClass
                canClear
              />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <SelectMultiComponent
                v-model="localFilter.countryId"
                :options="countryOptions"
                valueProp="value"
                placeholder="Страна"
                modifier="rectangular"
                clearClass
                canClear
              />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <ComponentInput
                placeholder="Председатель"
                mod="filter"
                v-model="localFilter.chairman"
                clearButton
                @onClear="handleClear('chairman')"
              />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <ComponentInput
                placeholder="Председатель"
                mod="filter"
                v-model="localFilter.chairmanForeign"
                clearButton
                @onClear="handleClear('chairmanForeign')"
              />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <ComponentInput
                placeholder="Заместитель"
                mod="filter"
                v-model="localFilter.coChairman"
                clearButton
                @onClear="handleClear('coChairman')"
              />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-l" scope="col">
              <ComponentInput
                placeholder="Секретарь"
                mod="filter"
                v-model="localFilter.secretary"
                clearButton
                @onClear="handleClear('secretary')"
              />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-m" scope="col">
              <DateComponent v-model="localFilter.lastEventFrom" clearable :dateIcon="false" modClass="filter" />
              <DateComponent v-model="localFilter.lastEventTo" clearable :dateIcon="false" modClass="filter" />
            </th>
            <th class="table-list-projects__td table-list-projects__td_size-m" scope="col">
              <DateComponent v-model="localFilter.lastEventZasedFrom" clearable :dateIcon="false" modClass="filter" />
              <DateComponent v-model="localFilter.lastEventZasedTo" clearable :dateIcon="false" modClass="filter" />
            </th>
          </tr>
        </thead>
        <tbody v-if="items && items.length">
          <tr
            v-for="commission in items"
            :key="commission.id"
            @dblclick="$emit('editCard', commission)"
            class="cursorPointer hover-tr"
            :class="{ 'tr-commission': !commission.parentId }"
          >
            <td
              class="table-list-projects__td table-list-projects__td_size-xs mpk-first-column-fixed"
              v-if="canEdit || canDelete"
            >
              <div class="table-list-projects__td-icons-wrap wrap-icon">
                <IconComponent
                  v-if="canEdit"
                  class="icon--full-svg"
                  @click.stop="$emit('editCard', commission)"
                  name="edit"
                />
                <IconComponent
                  v-if="canDelete"
                  class="icon--full-svg delete"
                  @click.stop="$emit('deleteCard', commission.id)"
                  name="delete-not-fill"
                />
              </div>
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-l">
              {{ commission.name }}
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-m">
              {{ commission.status?.name }}
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-l">
              {{ commission.country?.name }}
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-l">
              <template v-if="commission.chairman">
                <p class="name">{{ commission.chairman.name }}</p>
                {{ commission.chairman.position }}
              </template>
              <template v-else> (уточняется) </template>
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-l">
              <template v-if="commission.chairmanForeign">
                <p class="name">{{ commission.chairmanForeign.name }}</p>
                {{ commission.chairmanForeign.position }}
              </template>
              <template v-else> (уточняется) </template>
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-l">
              <template v-if="!commission.parentId">
                <template v-if="commission.coChairman">
                  <p class="name">{{ commission.coChairman.name }}</p>
                  {{ commission.coChairman.position }}
                </template>
                <template v-else> (уточняется) </template>
              </template>
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-l">
              <template v-if="!commission.parentId">
                <template v-if="commission.secretary">
                  <p class="name">{{ commission.secretary.name }}</p>
                  {{ commission.secretary.position }} {{ commission.secretary.phone }} {{ commission.secretary.email }}
                </template>
                <template v-else> (уточняется) </template>
              </template>
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-m">
              <template v-if="commission.lastEvent">
                <p class="date">
                  {{ $momentFormat(commission.lastEvent.eventFirstDate, Constants.DATE_FORMATS.DD_MMMM_YYYY) }}
                </p>
                {{ commission.lastEvent.place }}
              </template>
              <template v-else> (уточняется) </template>
            </td>
            <td class="table-list-projects__td table-list-projects__td_size-m">
              <template v-if="commission.lastEventZased">
                <p class="date">
                  {{ $momentFormat(commission.lastEventZased.eventLastPastDate, Constants.DATE_FORMATS.DD_MMMM_YYYY) }}
                </p>
                {{ commission.lastEventZased.place }}
              </template>
              <template v-else> (уточняется) </template>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="emptyRowColspan">Нет данных.</td>
          </tr>
        </tbody>
      </table>

      <div v-if="isLoading" class="table-list-projects__loader-wrapper" :style="{ width: '100%' }">
        <div class="table-list-projects__loader-viewport" :style="{ width: '100%' }">
          <Loader class="table-list-projects__loader" />
        </div>
      </div>
    </TableScrollbar>
  </div>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import Constants from '@/common/constants';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import Loader from '@/components/Loader.vue';
  import TableScrollbar from '@/components/TableScrollbar.vue';

  export default {
    name: 'TableListCommissions',
    components: { Loader, TableScrollbar, ComponentInput, SelectMultiComponent, DateComponent, IconComponent },
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      canEdit: {
        type: Boolean,
        default: false,
      },
      canDelete: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      filter: {
        type: Object,
        required: true,
      },
      countryOptions: {
        type: Array,
        required: true,
      },
      statusOptions: {
        type: Array,
        required: true,
      },
    },
    data() {
      return { Constants, localFilter: { ...this.filter }, isSyncingFromParent: false };
    },
    emits: ['editCard', 'deleteCard', 'update:filter'],
    computed: {
      emptyRowColspan() {
        return this.canEdit ? 10 : 9;
      },
    },
    methods: {
      handleClear(fieldName) {
        if (Object.hasOwn(this.localFilter, fieldName)) {
          this.localFilter[fieldName] = null;
        }
      },
    },
    watch: {
      filter: {
        handler(newVal) {
          this.isSyncingFromParent = true;
          this.localFilter = { ...newVal };
          this.$nextTick(() => {
            this.isSyncingFromParent = false;
          });
        },
        deep: true,
      },
      localFilter: {
        handler(newVal) {
          if (this.isSyncingFromParent) return;
          this.$emit('update:filter', { ...newVal });
        },
        deep: true,
      },
    },
  };
</script>

<style lang="scss">
  @import './../../mpkProject/styles/list-projects.scss';
  @import '@/assets/theme/default/table/table-list-projects.scss';

  .list-projects__results-table {
    min-height: 450px;
    z-index: 2;
  }
</style>
